import { I18N } from "oc-I18N";
import { HilfeIcon } from "../Auswahl";
import { ZaunCircleMenuItem } from "./ZaunCircleMenuItem";
import React from "react";

export function ZaunCircleMenuItemAOrBView() {
  const agt = APP.arrangement;
  const accessor = () => APP.arrangement.auswahlAccessoren.Füllungsseite;
  const contract = () =>
    agt.selectedObjects[0]?.isElement && accessor()?.möglicheAuswahlwerte?.length > 1;
  if (!contract()) {
    return null;
  }
  const element = agt.selectedObjects[0];

  const { auswahl, auswahlwert, möglicheAuswahlwerte, setter } = accessor();

  const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (
      !(e.target as HTMLElement).parentElement?.parentElement?.classList.contains(
        "zaunCircleMenuItem"
      )
    ) {
      // Verhindert, dass die Aktion ausgeführt wird durch Klicken in das Joyrider-Hilfs-Popup
      return null;
    }
    if (!contract()) {
      return null;
    }
    const elemente = agt.selectedObjects;
    elemente.forEach((e) => {
      e.anpassungDurchUser = true;
      e.seiteGewechselt = !e.seiteGewechselt;
      agt.elementeSeiteGewechselt.add(e);
    });
    APP.logUserAction({ action: "seiteGewechselt" });
    APP.dirty();
  };

  const isFlippedNormal = element.segment.flippedNormal;
  const seiteA = I18N("Seite A nach außen");
  const seiteB = I18N("Seite B nach außen");
  const füllungsseite = element.seiteGewechselt == isFlippedNormal ? seiteB : seiteA;
  const elementHinweistext = element.meta?.ABSeiteHinweistext;

  return (
    <ZaunCircleMenuItem onClick={onClick} dataButtonKey={füllungsseite}>
      <span aria-label={I18N("aria::Aktuelle Füllungsseite") + ": " + füllungsseite}>
        {füllungsseite}
      </span>

      {auswahlwert ? (
        <HilfeIcon
          Text={elementHinweistext || auswahlwert?.Hinweistext || auswahlwert?.Name}
          Bild={auswahlwert?.Auswahlbild}
        />
      ) : (
        <HilfeIcon Text={elementHinweistext || auswahl?.Hilfstext} Bild={auswahl?.Bild} />
      )}
    </ZaunCircleMenuItem>
  );
}
